export default __webpack_public_path__ + "7c0a7326c132773b80bcce9547c15412.svg";